import React, { useState, useEffect } from 'react';

// ============================================================
// CONFIG + HELPERS
// ============================================================

var API = process.env.REACT_APP_API_URL || '';

async function api(path, opts) {
  var o = opts || {};
  var headers = o.headers || {};
  if (!(o.body instanceof FormData)) headers['Content-Type'] = 'application/json';
  var res = await fetch(API + '/api' + path, { credentials: 'include', method: o.method || 'GET', headers: headers, body: o.body || undefined });
  return res.json();
}

function formatDH(v) {
  if (v === null || v === undefined || v === 0) return '--';
  return v.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' DH';
}

function calcCurrent(amount, rate, dateStr) {
  if (!amount || !rate || !dateStr) return null;
  var d = new Date(dateStr);
  if (isNaN(d)) return null;
  var years = (Date.now() - d.getTime()) / (365.25 * 24 * 3600000);
  if (years <= 0) return null;
  return amount * Math.pow(1 + rate / 100, years);
}

function getCategory(type) {
  var t = (type || '').toLowerCase();
  if (t.indexOf('judiciaire') !== -1) return 'hypotheque_judiciaire';
  if (t.indexOf('conventionnelle') !== -1) return 'hypotheque_bancaire';
  if (t.indexOf('saisie') !== -1 && t.indexOf('execution') !== -1) return 'saisie_execution';
  if (t.indexOf('saisie') !== -1) return 'saisie_conservatoire';
  if (t.indexOf('inscription') !== -1) return 'inscription_provisoire';
  return 'hypotheque_bancaire';
}

var ACTION_MAP = {
  hypotheque_bancaire: { label: 'Negocier main levee bancaire', bg: '#dbeafe', color: '#1e40af' },
  hypotheque_judiciaire: { label: 'Regulariser impots + mainlevee fiscale', bg: '#ffedd5', color: '#9a3412' },
  saisie_conservatoire: { label: 'Contester ou rembourser saisie', bg: '#fef3c7', color: '#92400e' },
  saisie_execution: { label: 'Opposition ou mainlevee judiciaire', bg: '#fee2e2', color: '#991b1b' },
  inscription_provisoire: { label: 'Verifier et radier inscription', bg: '#f3e8ff', color: '#6b21a8' },
};

// ============================================================
// STYLES
// ============================================================

var S = {
  page: { minHeight: '100vh', background: '#fff', fontFamily: 'system-ui, -apple-system, sans-serif', color: '#1f2937' },
  center: { display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', background: '#f3f4f6' },
  loginCard: { background: '#fff', borderRadius: 12, padding: 32, width: 380, boxShadow: '0 4px 24px rgba(0,0,0,0.08)' },
  input: { width: '100%', padding: '10px 12px', fontSize: 14, border: '1px solid #d1d5db', borderRadius: 8, outline: 'none', boxSizing: 'border-box' },
  btnP: { width: '100%', padding: '10px 0', fontSize: 14, fontWeight: 600, background: '#1f2937', color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer' },
  btnS: { padding: '7px 14px', fontSize: 13, fontWeight: 500, background: '#f3f4f6', border: '1px solid #d1d5db', borderRadius: 8, cursor: 'pointer', color: '#374151' },
  btnD: { padding: '7px 14px', fontSize: 13, fontWeight: 500, background: '#1f2937', color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer' },
  header: { borderBottom: '1px solid #e5e7eb', background: '#fff', padding: '16px 0' },
  maxW: { maxWidth: 1280, margin: '0 auto', padding: '0 20px' },
  row: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 8 },
  h1: { fontSize: 22, fontWeight: 700, color: '#1f2937', margin: 0 },
  sub: { fontSize: 13, color: '#6b7280', marginTop: 2 },
  grid6: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: 10, padding: '14px 0' },
  statCard: { background: '#f3f4f6', border: '1px solid #e5e7eb', borderRadius: 8, padding: 12 },
  statLabel: { fontSize: 10, fontWeight: 500, color: '#6b7280', textTransform: 'uppercase', letterSpacing: 0.5 },
  statVal: { fontSize: 20, fontWeight: 700, color: '#1f2937', marginTop: 2 },
  tabBar: { display: 'flex', borderBottom: '1px solid #e5e7eb', gap: 0, overflowX: 'auto' },
  tab: { padding: '10px 18px', fontSize: 13, fontWeight: 500, background: 'none', border: 'none', borderBottom: '2px solid transparent', cursor: 'pointer', color: '#6b7280', whiteSpace: 'nowrap' },
  tabA: { padding: '10px 18px', fontSize: 13, fontWeight: 500, background: 'none', border: 'none', borderBottom: '2px solid #1f2937', cursor: 'pointer', color: '#1f2937', whiteSpace: 'nowrap' },
  card: { background: '#fff', border: '1px solid #e5e7eb', borderRadius: 8, marginBottom: 14, overflow: 'hidden' },
  cardH: { width: '100%', textAlign: 'left', padding: '14px 18px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: 'none', border: 'none', cursor: 'pointer' },
  badge: { display: 'inline-block', padding: '2px 8px', fontSize: 11, fontWeight: 600, borderRadius: 10 },
  table: { width: '100%', borderCollapse: 'collapse', fontSize: 12 },
  th: { textAlign: 'left', padding: '8px 10px', background: '#f9fafb', fontSize: 10, fontWeight: 500, color: '#6b7280', textTransform: 'uppercase', letterSpacing: 0.5, borderBottom: '1px solid #e5e7eb' },
  td: { padding: '8px 10px', borderBottom: '1px solid #f3f4f6', verticalAlign: 'top' },
  tdR: { padding: '8px 10px', borderBottom: '1px solid #f3f4f6', textAlign: 'right', fontFamily: 'monospace', verticalAlign: 'top' },
  toggle: { display: 'inline-block', padding: '2px 10px', fontSize: 11, fontWeight: 600, borderRadius: 16, cursor: 'pointer', border: 'none' },
  cardF: { borderTop: '1px solid #e5e7eb', padding: '10px 18px', background: '#f9fafb', display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: 8, fontSize: 13 },
  modal: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 },
  modalBox: { background: '#fff', borderRadius: 12, width: '100%', maxWidth: 620, maxHeight: '85vh', display: 'flex', flexDirection: 'column', margin: 16, boxShadow: '0 20px 60px rgba(0,0,0,0.2)' },
  modalH: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '14px 18px', borderBottom: '1px solid #e5e7eb' },
  modalB: { overflow: 'auto', padding: 18, flex: 1 },
  upload: { border: '2px dashed #d1d5db', borderRadius: 12, padding: 40, textAlign: 'center', background: '#f9fafb' },
  uploadA: { border: '2px dashed #3b82f6', borderRadius: 12, padding: 40, textAlign: 'center', background: '#eff6ff' },
  err: { background: '#fef2f2', border: '1px solid #fecaca', borderRadius: 8, padding: 10, fontSize: 13, color: '#991b1b', marginTop: 10 },
  ok: { background: '#ecfdf5', border: '1px solid #bbf7d0', borderRadius: 8, padding: 10, fontSize: 13, color: '#065f46', marginTop: 10 },
  cityNode: { position: 'absolute', transform: 'translate(-50%, -50%)', border: '2px solid', borderRadius: 10, padding: 12, minWidth: 150, boxShadow: '0 2px 8px rgba(0,0,0,0.08)' },
  planCard: { border: '1px solid #e5e7eb', borderRadius: 10, padding: 14, marginBottom: 10 },
  planPrio: { display: 'flex', alignItems: 'center', justifyContent: 'center', width: 28, height: 28, borderRadius: '50%', background: '#1f2937', color: '#fff', fontSize: 13, fontWeight: 700, flexShrink: 0 },
  progBar: { height: 5, background: '#e5e7eb', borderRadius: 3, overflow: 'hidden', width: 100 },
  crossPanel: { background: '#eef2ff', border: '1px solid #c7d2fe', borderRadius: 10, padding: 16, marginBottom: 16 },
  docCard: { border: '1px solid #e5e7eb', borderRadius: 8, padding: 12, marginBottom: 8, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 8 },
};

// ============================================================
// SETUP PAGE
// ============================================================

function SetupPage({ onDone }) {
  var [ap, setAp] = useState('');
  var [vp, setVp] = useState('');
  var [loading, setLoading] = useState(false);
  var [err, setErr] = useState('');

  async function submit(e) {
    e.preventDefault();
    if (ap.length < 6 || vp.length < 6) { setErr('Minimum 6 caracteres par mot de passe'); return; }
    setLoading(true); setErr('');
    var res = await api('/auth/setup', { method: 'POST', body: JSON.stringify({ adminPassword: ap, avocatPassword: vp }) });
    setLoading(false);
    if (res.error) { setErr(res.error); return; }
    onDone();
  }

  return (
    <div style={S.center}>
      <form onSubmit={submit} style={S.loginCard}>
        <h2 style={{ fontSize: 20, fontWeight: 700, marginBottom: 4, color: '#1f2937' }}>Configuration initiale</h2>
        <p style={{ fontSize: 13, color: '#6b7280', marginBottom: 20 }}>Creez les comptes pour le tableau de bord</p>
        <div style={{ marginBottom: 14 }}>
          <label style={{ fontSize: 12, fontWeight: 500, color: '#374151', display: 'block', marginBottom: 4 }}>Mot de passe admin (youssef)</label>
          <input style={S.input} type="password" value={ap} onChange={function (e) { setAp(e.target.value); }} placeholder="Minimum 6 caracteres" />
        </div>
        <div style={{ marginBottom: 14 }}>
          <label style={{ fontSize: 12, fontWeight: 500, color: '#374151', display: 'block', marginBottom: 4 }}>Mot de passe avocat (avocat)</label>
          <input style={S.input} type="password" value={vp} onChange={function (e) { setVp(e.target.value); }} placeholder="Minimum 6 caracteres" />
        </div>
        {err && <div style={S.err}>{err}</div>}
        <button style={Object.assign({}, S.btnP, { marginTop: 12 })} disabled={loading}>{loading ? 'Creation...' : 'Creer les comptes'}</button>
      </form>
    </div>
  );
}

// ============================================================
// LOGIN PAGE
// ============================================================

function LoginPage({ onLogin }) {
  var [u, setU] = useState('');
  var [p, setP] = useState('');
  var [loading, setLoading] = useState(false);
  var [err, setErr] = useState('');

  async function submit(e) {
    e.preventDefault();
    setLoading(true); setErr('');
    var res = await api('/auth/login', { method: 'POST', body: JSON.stringify({ username: u, password: p }) });
    setLoading(false);
    if (res.error) { setErr(res.error); return; }
    onLogin(res.user);
  }

  return (
    <div style={S.center}>
      <form onSubmit={submit} style={S.loginCard}>
        <h2 style={{ fontSize: 20, fontWeight: 700, marginBottom: 4, color: '#1f2937' }}>Purification des Titres</h2>
        <p style={{ fontSize: 13, color: '#6b7280', marginBottom: 20 }}>Dossier Amrouche -- Connexion</p>
        <div style={{ marginBottom: 14 }}>
          <label style={{ fontSize: 12, fontWeight: 500, color: '#374151', display: 'block', marginBottom: 4 }}>Nom d utilisateur</label>
          <input style={S.input} value={u} onChange={function (e) { setU(e.target.value); }} placeholder="youssef ou avocat" />
        </div>
        <div style={{ marginBottom: 14 }}>
          <label style={{ fontSize: 12, fontWeight: 500, color: '#374151', display: 'block', marginBottom: 4 }}>Mot de passe</label>
          <input style={S.input} type="password" value={p} onChange={function (e) { setP(e.target.value); }} />
        </div>
        {err && <div style={S.err}>{err}</div>}
        <button style={Object.assign({}, S.btnP, { marginTop: 12 })} disabled={loading}>{loading ? 'Connexion...' : 'Se connecter'}</button>
      </form>
    </div>
  );
}

// ============================================================
// MAIN APP
// ============================================================

function App() {
  var [user, setUser] = useState(null);
  var [authLoading, setAuthLoading] = useState(true);
  var [setupRequired, setSetupRequired] = useState(false);

  var [properties, setProperties] = useState([]);
  var [crossDebts, setCrossDebts] = useState([]);
  var [activeTab, setActiveTab] = useState('overview');
  var [expanded, setExpanded] = useState({});
  var [expandedCL, setExpandedCL] = useState({});

  var [letterModal, setLetterModal] = useState({ open: false, content: '', loading: false });
  var [matchModal, setMatchModal] = useState({ open: false, matches: [], justId: null, aiResult: null });
  var [selectedMatch, setSelectedMatch] = useState(null);

  var [actionPlan, setActionPlan] = useState([]);
  var [planLoading, setPlanLoading] = useState(false);
  var [planErr, setPlanErr] = useState('');

  var [uploading, setUploading] = useState(false);
  var [uploadMsg, setUploadMsg] = useState({ t: '', type: '' });
  var [dragOver, setDragOver] = useState(false);
  var [batchFiles, setBatchFiles] = useState([]);  // [{name, status: 'pending'|'processing'|'done'|'error', message}]
  var [batchRunning, setBatchRunning] = useState(false);

  var isAdmin = user && user.role === 'admin';

  // --- Auth check ---
  useEffect(function () {
    api('/auth/me').then(function (res) {
      if (res.setup_required) { setSetupRequired(true); }
      else if (res.user) { setUser(res.user); }
      setAuthLoading(false);
    }).catch(function () { setAuthLoading(false); });
  }, []);

  // --- Load data ---
  function loadData() {
    api('/properties').then(function (res) { if (res.properties) setProperties(res.properties); });
    api('/cross-debts').then(function (res) { if (res.crossDebts) setCrossDebts(res.crossDebts); });
  }

  useEffect(function () { if (user) loadData(); }, [user]);

  async function logout() {
    await api('/auth/logout', { method: 'POST' });
    setUser(null);
  }

  // --- Main levee toggle ---
  async function toggleML(encId, current) {
    var next = current === 'none' ? 'obtained' : current === 'obtained' ? 'documented' : 'none';
    await api('/encumbrances/' + encId + '/mainlevee', { method: 'PATCH', body: JSON.stringify({ status: next }) });
    loadData();
  }

  // --- Checklist ---
  async function toggleCheck(encId, itemId, checked) {
    await api('/encumbrances/' + encId + '/checklist', { method: 'PATCH', body: JSON.stringify({ itemId: itemId, checked: !checked }) });
    loadData();
  }

  // --- Letter ---
  async function genLetter(prop, enc) {
    setLetterModal({ open: true, content: '', loading: true });
    var res = await api('/ai/generate-letter', { method: 'POST', body: JSON.stringify({ propertyRef: prop.ref, propertyName: prop.name, location: prop.location, type: enc.type, date: enc.date, rank: enc.rank, amount: enc.amount, debtor: enc.debtor, creditor: enc.creditor, interdiction: enc.interdiction_type }) });
    setLetterModal({ open: true, content: res.letter || res.error || 'Erreur', loading: false });
  }

  // --- Upload justificatif (single file, existing) ---
  async function handleUpload(file) {
    if (!file) return;
    setUploading(true);
    setUploadMsg({ t: 'Analyse en cours...', type: 'info' });
    var fd = new FormData();
    fd.append('file', file);
    var res = await api('/justificatifs/upload', { method: 'POST', body: fd, headers: {} });
    setUploading(false);
    if (res.error) { setUploadMsg({ t: res.error, type: 'err' }); return; }
    if (res.matches && res.matches.length > 0) {
      setMatchModal({ open: true, matches: res.matches, justId: res.justificatifId, aiResult: res.aiResult });
      setSelectedMatch(res.matches[0].encumbranceId);
    } else {
      setUploadMsg({ t: 'Document uploade. Aucune correspondance trouvee.', type: 'ok' });
    }
    loadData();
  }

  // --- Batch upload titres fonciers (multi-file) ---
  async function handleBatchUpload(fileList) {
    if (!fileList || fileList.length === 0) return;
    var files = [];
    for (var i = 0; i < fileList.length; i++) {
      if (fileList[i].type === 'application/pdf' || fileList[i].name.toLowerCase().endsWith('.pdf')) {
        files.push({ file: fileList[i], name: fileList[i].name, status: 'pending', message: 'En attente' });
      }
    }
    if (files.length === 0) { setUploadMsg({ t: 'Aucun fichier PDF selectionne.', type: 'err' }); return; }
    setBatchFiles(files);
    setBatchRunning(true);
    setUploadMsg({ t: '', type: '' });

    var successCount = 0;
    var errorCount = 0;

    async function processFile(idx) {
      setBatchFiles(function (prev) {
        var next = prev.slice();
        next[idx] = Object.assign({}, next[idx], { status: 'processing', message: 'Analyse en cours...' });
        return next;
      });

      try {
        var buffer = await files[idx].file.arrayBuffer();
        var bytes = new Uint8Array(buffer);
        var binary = '';
        for (var b = 0; b < bytes.length; b++) binary += String.fromCharCode(bytes[b]);
        var base64 = btoa(binary);

        var aiRes = await api('/ai/analyze-document', {
          method: 'POST',
          body: JSON.stringify({ base64: base64, mediaType: 'application/pdf' }),
        });

        if (aiRes.error) throw new Error(aiRes.error);
        var parsed = aiRes.result;
        if (!parsed || !parsed.ref) throw new Error('Donnees extraites insuffisantes');

        var propRes = await api('/properties', {
          method: 'POST',
          body: JSON.stringify({
            ref: parsed.ref,
            name: parsed.name || null,
            location: parsed.location || null,
            surface: parsed.surface || null,
            nature: parsed.nature || null,
            conservation_fonciere: parsed.conservationFonciere || null,
            owners: parsed.owners || [],
            encumbrances: (parsed.encumbrances || []).map(function (e) {
              return {
                type: e.type || '',
                date: e.date || null,
                rank: e.rank || null,
                amount: e.amount || 0,
                rate: e.rate || 0,
                creditor: e.creditor || null,
                debtor: e.debtor || null,
                has_interdiction: e.hasInterdiction || false,
                interdiction_type: e.interdictionType || null,
              };
            }),
          }),
        });

        if (propRes.error) throw new Error(propRes.error);

        successCount++;
        setBatchFiles(function (prev) {
          var next = prev.slice();
          next[idx] = Object.assign({}, next[idx], { status: 'done', message: 'Titre ' + parsed.ref + ' importe' });
          return next;
        });
      } catch (err) {
        errorCount++;
        setBatchFiles(function (prev) {
          var next = prev.slice();
          next[idx] = Object.assign({}, next[idx], { status: 'error', message: err.message || 'Erreur inconnue' });
          return next;
        });
      }
    }

    for (var idx = 0; idx < files.length; idx++) {
      await processFile(idx);
    }

    setBatchRunning(false);
    var summary = successCount + ' titre(s) importe(s) avec succes';
    if (errorCount > 0) summary += ', ' + errorCount + ' erreur(s)';
    setUploadMsg({ t: summary, type: errorCount > 0 ? 'err' : 'ok' });
    loadData();
  }

  async function confirmMatch() {
    if (!selectedMatch || !matchModal.justId) return;
    await api('/justificatifs/link', { method: 'POST', body: JSON.stringify({ justificatifId: matchModal.justId, encumbranceId: selectedMatch }) });
    setMatchModal({ open: false, matches: [], justId: null, aiResult: null });
    setUploadMsg({ t: 'Document lie avec succes.', type: 'ok' });
    loadData();
  }

  // --- Action plan ---
  async function genPlan() {
    setPlanLoading(true); setPlanErr('');
    var res = await api('/ai/action-plan', { method: 'POST', body: JSON.stringify({}) });
    setPlanLoading(false);
    if (res.error) { setPlanErr(res.error); return; }
    setActionPlan(res.plan || []);
    if (res.message) setPlanErr(res.message);
  }

  // --- Summary ---
  var allEnc = [];
  properties.forEach(function (p) { allEnc = allEnc.concat(p.encumbrances || []); });
  var totalDebt = allEnc.reduce(function (s, e) { return s + (e.amount || 0); }, 0);
  var titreNet = properties.filter(function (p) { return !p.encumbrances || p.encumbrances.length === 0; }).length;
  var mlObtained = allEnc.filter(function (e) { return e.main_levee_status !== 'none'; }).length;
  var globalPct = allEnc.length > 0 ? Math.round((mlObtained / allEnc.length) * 100) : 100;

  // Cross-debt enc IDs for badge display
  var crossDebtEncIds = {};
  crossDebts.forEach(function (g) { g.entries.forEach(function (e) { crossDebtEncIds[e.encumbranceId] = g.groupId; }); });

  // City data for map
  var cityData = {};
  properties.forEach(function (p) {
    var c = p.city || 'Autre';
    if (!cityData[c]) cityData[c] = { count: 0, enc: 0, obtained: 0, total: 0 };
    cityData[c].count++;
    (p.encumbrances || []).forEach(function (e) {
      cityData[c].enc++;
      cityData[c].total++;
      if (e.main_levee_status !== 'none') cityData[c].obtained++;
    });
  });

  // --- Render ---
  if (authLoading) return <div style={S.center}><p style={{ color: '#6b7280' }}>Chargement...</p></div>;
  if (setupRequired) return <SetupPage onDone={function () { setSetupRequired(false); }} />;
  if (!user) return <LoginPage onLogin={function (u) { setUser(u); }} />;

  return (
    <div style={S.page}>
      {/* Header */}
      <header style={S.header}>
        <div style={Object.assign({}, S.maxW, S.row)}>
          <div>
            <h1 style={S.h1}>Tableau de Bord -- Purification des Titres</h1>
            <p style={S.sub}>Dossier Amrouche | {user.username} ({user.role})</p>
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            <button style={S.btnS} onClick={function () { window.print(); }}>Export PDF</button>
            <button style={S.btnS} onClick={logout}>Deconnexion</button>
          </div>
        </div>
      </header>

      {/* Summary */}
      <div style={S.maxW}>
        <div style={S.grid6}>
          {[
            { l: 'Titres fonciers', v: properties.length },
            { l: 'Charges totales', v: allEnc.length },
            { l: 'Dette totale', v: formatDH(totalDebt) },
            { l: 'Titres nets', v: titreNet },
            { l: 'Main levees', v: mlObtained + ' / ' + allEnc.length },
            { l: 'Purification', v: globalPct + '%' },
          ].map(function (item) {
            return <div key={item.l} style={S.statCard}><div style={S.statLabel}>{item.l}</div><div style={S.statVal}>{item.v}</div></div>;
          })}
        </div>
      </div>

      {/* Tabs */}
      <div style={S.maxW}>
        <div style={S.tabBar}>
          {[
            { id: 'overview', l: 'Vue d ensemble' },
            { id: 'plan', l: 'Plan d Action' },
            { id: 'map', l: 'Carte des biens' },
            { id: 'docs', l: 'Documents' },
            { id: 'upload', l: 'Upload document' },
          ].map(function (t) {
            return <button key={t.id} style={activeTab === t.id ? S.tabA : S.tab} onClick={function () { setActiveTab(t.id); }}>{t.l}</button>;
          })}
        </div>
      </div>

      {/* Content */}
      <div style={Object.assign({}, S.maxW, { paddingTop: 20, paddingBottom: 20 })}>

        {/* ===== OVERVIEW ===== */}
        {activeTab === 'overview' && <>
          {/* Cross-debt panel */}
          {crossDebts.length > 0 && (
            <div style={S.crossPanel}>
              <h3 style={{ fontSize: 15, fontWeight: 600, color: '#3730a3', margin: '0 0 10px 0' }}>Dettes Communes Detectees</h3>
              {crossDebts.map(function (g) {
                return (
                  <div key={g.groupId} style={{ marginBottom: 8, padding: 10, background: '#fff', borderRadius: 8, border: '1px solid #c7d2fe' }}>
                    <div style={{ fontSize: 13, fontWeight: 500 }}>{g.creditor} -- {formatDH(g.amount)}</div>
                    <div style={{ fontSize: 12, color: '#6b7280', marginTop: 4 }}>
                      {g.entries.map(function (e) { return e.propertyRef + ' (' + e.propertyName + ')'; }).join(' | ')}
                    </div>
                  </div>
                );
              })}
            </div>
          )}

          {/* Property cards */}
          {properties.map(function (prop) {
            var isExp = expanded[prop.id];
            var encs = prop.encumbrances || [];
            var propDebt = encs.reduce(function (s, e) { return s + (e.amount || 0); }, 0);
            var propML = encs.filter(function (e) { return e.main_levee_status !== 'none'; }).length;
            var isNet = encs.length === 0;
            var hasInterdiction = encs.some(function (e) { return e.has_interdiction; });

            // Compute top 3 creditors with totals
            var creditorTotals = {};
            encs.forEach(function (e) {
              if (e.creditor) {
                var key = e.creditor;
                creditorTotals[key] = (creditorTotals[key] || 0) + (e.amount || 0);
              }
            });
            var topCreditors = Object.keys(creditorTotals).map(function (k) { return { name: k, total: creditorTotals[k] }; });
            topCreditors.sort(function (a, b) { return b.total - a.total; });
            topCreditors = topCreditors.slice(0, 3);

            return (
              <div key={prop.id} style={S.card}>
                <button style={S.cardH} onClick={function () { setExpanded(function (prev) { var n = Object.assign({}, prev); n[prop.id] = !n[prop.id]; return n; }); }}>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>
                      <span style={{ fontSize: 14, fontWeight: 600 }}>{prop.ref} -- {prop.name || 'Titre foncier'}</span>
                      <span style={Object.assign({}, S.badge, { background: '#f3f4f6', color: '#6b7280' })}>{prop.nature}</span>
                      {isNet && <span style={Object.assign({}, S.badge, { background: '#d1fae5', color: '#059669' })}>+ Titre net</span>}
                      {hasInterdiction && <span style={Object.assign({}, S.badge, { background: '#fee2e2', color: '#dc2626', fontWeight: 700 })}>! INTERDICTION</span>}
                    </div>
                    <p style={{ fontSize: 12, color: '#6b7280', marginTop: 3, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                      {prop.location}{prop.surface ? ' | ' + prop.surface : ''} | {encs.length} charge(s) | {formatDH(propDebt)}{encs.length > 0 ? ' | ML: ' + propML + '/' + encs.length : ''}
                    </p>
                    {topCreditors.length > 0 && (
                      <p style={{ fontSize: 11, color: '#9ca3af', marginTop: 2, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        Creanciers: {topCreditors.map(function (c) { return c.name + ' (' + formatDH(c.total) + ')'; }).join(' | ')}
                      </p>
                    )}
                  </div>
                  <span style={{ fontSize: 16, color: '#9ca3af' }}>{isExp ? '-' : '+'}</span>
                </button>

                {isExp && (
                  <div>
                    <div style={{ padding: '10px 18px', background: '#f9fafb', fontSize: 12, color: '#6b7280', borderBottom: '1px solid #e5e7eb' }}>
                      <b style={{ color: '#374151' }}>Proprietaires :</b> {(prop.owners || []).map(function (o) { return o.name + ' (' + o.share + ')'; }).join(' | ')}
                    </div>

                    {isNet ? (
                      <div style={{ padding: '28px 18px', textAlign: 'center' }}>
                        <span style={Object.assign({}, S.badge, { background: '#d1fae5', color: '#059669', fontSize: 13, padding: '5px 14px' })}>+ Titre net -- aucune charge</span>
                      </div>
                    ) : (
                      <div style={{ overflowX: 'auto' }}>
                        <table style={S.table}>
                          <thead>
                            <tr>
                              {['N.', 'Type', 'Date', 'Rang', 'Montant', 'Actuel', 'Creancier', 'Debiteur', 'Main Levee', 'Action', ''].map(function (h) {
                                return <th key={h} style={Object.assign({}, S.th, h === 'Montant' || h === 'Actuel' ? { textAlign: 'right' } : h === 'Main Levee' ? { textAlign: 'center' } : {})}>{h}</th>;
                              })}
                            </tr>
                          </thead>
                          <tbody>
                            {encs.map(function (enc, idx) {
                              var cat = getCategory(enc.type);
                              var act = ACTION_MAP[cat];
                              var cur = calcCurrent(enc.amount, enc.rate, enc.date);
                              var isHigher = cur && enc.amount && cur > enc.amount * 1.5;
                              var isTres = (enc.creditor || '').toLowerCase().indexOf('tresorerie') !== -1;
                              var mlStatus = enc.main_levee_status || 'none';
                              var mlColors = { none: { bg: '#fee2e2', color: '#991b1b', label: '- Non obtenue' }, obtained: { bg: '#d1fae5', color: '#059669', label: '+ Obtenue' }, documented: { bg: '#a7f3d0', color: '#065f46', label: '[D] Documentee' } };
                              var ml = mlColors[mlStatus];
                              var hasCrossDebt = crossDebtEncIds[enc.id];
                              var clItems = enc.checklist || [];
                              var clDone = clItems.filter(function (c) { return c.checked; }).length;
                              var clPct = clItems.length > 0 ? Math.round((clDone / clItems.length) * 100) : 0;
                              var justCount = (enc.justificatifs || []).length;
                              var isClOpen = expandedCL[enc.id];

                              return (
                                <React.Fragment key={enc.id}>
                                  <tr style={{ background: mlStatus !== 'none' ? '#f0fdf4' : 'transparent' }}>
                                    <td style={S.td}>{idx + 1}</td>
                                    <td style={S.td}>
                                      <span style={{ fontWeight: 500 }}>{enc.type}</span>
                                      {hasCrossDebt && <span style={Object.assign({}, S.badge, { background: '#e0e7ff', color: '#4f46e5', marginLeft: 4 })}>Dette commune</span>}
                                      {isTres && <span style={Object.assign({}, S.badge, { background: '#fee2e2', color: '#dc2626', marginLeft: 4, fontWeight: 700 })}>! WARNING</span>}
                                      {enc.has_interdiction ? <div style={{ marginTop: 3 }}><span style={Object.assign({}, S.badge, { background: '#fee2e2', color: '#dc2626', fontWeight: 700 })}>{enc.interdiction_type || 'INTERDICTION'}</span></div> : null}
                                    </td>
                                    <td style={S.td}>{enc.date}</td>
                                    <td style={S.td}>{enc.rank || '--'}</td>
                                    <td style={S.tdR}>{formatDH(enc.amount)}</td>
                                    <td style={Object.assign({}, S.tdR, isHigher ? { color: '#d97706', fontWeight: 600 } : {})}>{cur ? formatDH(cur) : '--'}{isHigher ? ' !' : ''}</td>
                                    <td style={Object.assign({}, S.td, { maxWidth: 140, overflow: 'hidden', textOverflow: 'ellipsis' })} title={enc.creditor}>{enc.creditor}</td>
                                    <td style={S.td}>{enc.debtor || '--'}</td>
                                    <td style={Object.assign({}, S.td, { textAlign: 'center' })}>
                                      {isAdmin ? (
                                        <button onClick={function () { toggleML(enc.id, mlStatus); }} style={Object.assign({}, S.toggle, { background: ml.bg, color: ml.color })}>{ml.label}</button>
                                      ) : (
                                        <span style={Object.assign({}, S.badge, { background: ml.bg, color: ml.color })}>{ml.label}</span>
                                      )}
                                    </td>
                                    <td style={S.td}>
                                      <span style={Object.assign({}, S.badge, { background: act.bg, color: act.color })}>{act.label}</span>
                                    </td>
                                    <td style={Object.assign({}, S.td, { whiteSpace: 'nowrap' })}>
                                      <button style={Object.assign({}, S.btnS, { padding: '3px 6px', fontSize: 10, marginRight: 3 })} onClick={function () { setExpandedCL(function (prev) { var n = Object.assign({}, prev); n[enc.id] = !n[enc.id]; return n; }); }}>
                                        {isClOpen ? '- ' : '+ '}{clPct}%
                                      </button>
                                      {justCount > 0 && <span style={Object.assign({}, S.badge, { background: '#dbeafe', color: '#1e40af', marginRight: 3 })}>{justCount} doc</span>}
                                      {isAdmin && <button style={Object.assign({}, S.btnS, { padding: '3px 6px', fontSize: 10 })} onClick={function () { genLetter(prop, enc); }}>Courrier</button>}
                                    </td>
                                  </tr>
                                  {isClOpen && (
                                    <tr>
                                      <td colSpan={11} style={{ padding: '8px 18px 12px 36px', background: '#fafafa', borderBottom: '1px solid #f3f4f6' }}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }}>
                                          <span style={{ fontSize: 11, fontWeight: 500, color: '#6b7280' }}>Avancement :</span>
                                          <div style={S.progBar}><div style={{ height: '100%', borderRadius: 3, background: clPct === 100 ? '#059669' : '#3b82f6', width: clPct + '%', transition: 'width 0.3s' }} /></div>
                                          <span style={{ fontSize: 11, fontWeight: 600, color: '#374151' }}>{clPct}%</span>
                                        </div>
                                        {clItems.map(function (ci) {
                                          return (
                                            <label key={ci.id} style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '3px 0', cursor: isAdmin ? 'pointer' : 'default', fontSize: 12, color: ci.checked ? '#9ca3af' : '#374151' }}>
                                              <input type="checkbox" checked={!!ci.checked} disabled={!isAdmin} onChange={function () { toggleCheck(enc.id, ci.id, ci.checked); }} />
                                              <span style={ci.checked ? { textDecoration: 'line-through' } : {}}>{ci.label}</span>
                                            </label>
                                          );
                                        })}
                                      </td>
                                    </tr>
                                  )}
                                </React.Fragment>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    )}

                    {encs.length > 0 && (
                      <div style={S.cardF}>
                        <div><b>Dette totale :</b> <span style={{ fontWeight: 700 }}>{formatDH(propDebt)}</span></div>
                        <div><b>Main levees :</b> <span style={{ fontWeight: 700, color: propML === encs.length ? '#059669' : '#1f2937' }}>{propML} / {encs.length}</span> <span style={{ fontSize: 11, color: '#9ca3af' }}>({encs.length > 0 ? Math.round((propML / encs.length) * 100) : 0}%)</span></div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            );
          })}
        </>}

        {/* ===== PLAN D'ACTION ===== */}
        {activeTab === 'plan' && (
          <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 8, padding: 20 }}>
            <div style={S.row}>
              <h2 style={{ fontSize: 17, fontWeight: 600, margin: 0 }}>Plan d Action -- Purification des Titres</h2>
              <button style={Object.assign({}, S.btnD, { display: 'flex', alignItems: 'center', gap: 6 })} onClick={genPlan} disabled={planLoading}>
                {planLoading ? 'Generation...' : actionPlan.length ? 'Regenerer' : 'Generer le plan (IA)'}
              </button>
            </div>
            {planErr && <div style={S.err}>{planErr}</div>}
            {actionPlan.length === 0 && !planLoading && !planErr && <div style={{ textAlign: 'center', padding: '40px 0', color: '#9ca3af', fontSize: 13 }}>Cliquez sur "Generer le plan" pour obtenir un plan d action priorise par l IA.</div>}
            <div style={{ marginTop: 14 }}>
              {actionPlan.map(function (item, i) {
                var uc = { haute: { bg: '#fee2e2', c: '#991b1b' }, moyenne: { bg: '#fef3c7', c: '#92400e' }, normale: { bg: '#d1fae5', c: '#065f46' } };
                var u = uc[item.urgency] || uc.normale;
                return (
                  <div key={i} style={S.planCard}>
                    <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 10 }}>
                      <div style={{ display: 'flex', alignItems: 'flex-start', gap: 10 }}>
                        <span style={S.planPrio}>{item.priority}</span>
                        <div><div style={{ fontWeight: 500 }}>{item.action}</div><div style={{ fontSize: 12, color: '#6b7280', marginTop: 2 }}>{item.property} | {item.encumbrance}</div></div>
                      </div>
                      <span style={Object.assign({}, S.badge, { background: u.bg, color: u.c })}>{item.urgency}</span>
                    </div>
                    <div style={{ marginTop: 6, fontSize: 12, color: '#4b5563' }}>{item.reason}</div>
                    <div style={{ marginTop: 6, display: 'flex', gap: 14, fontSize: 11, color: '#6b7280' }}>
                      <span>Duree : {item.estimatedDuration}</span><span>Cout : {item.estimatedCost}</span>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {/* ===== MAP ===== */}
        {activeTab === 'map' && (
          <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 8, padding: 20 }}>
            <h2 style={{ fontSize: 17, fontWeight: 600, margin: '0 0 14px 0' }}>Carte des biens</h2>
            <div style={{ position: 'relative', width: '100%', height: 480, background: '#f9fafb', border: '1px solid #e5e7eb', borderRadius: 10 }}>
              <div style={{ position: 'absolute', top: 10, left: 14, fontSize: 10, color: '#9ca3af', fontWeight: 500, textTransform: 'uppercase', letterSpacing: 1 }}>Maroc</div>
              {[
                { name: 'Mdiq', label: 'Mdiq / Tetouan', top: '12%', left: '52%' },
                { name: 'Casablanca', label: 'Casablanca', top: '38%', left: '22%' },
                { name: 'Beni-Mellal', label: 'Beni-Mellal', top: '48%', left: '52%' },
                { name: 'Agadir', label: 'Agadir', top: '72%', left: '18%' },
              ].map(function (city) {
                var d = cityData[city.name] || { count: 0, enc: 0, obtained: 0, total: 0 };
                var pct = d.total > 0 ? Math.round((d.obtained / d.total) * 100) : (d.count > 0 ? 100 : 0);
                var bc = pct >= 75 ? '#059669' : pct >= 25 ? '#d97706' : '#dc2626';
                var bg = pct >= 75 ? '#ecfdf5' : pct >= 25 ? '#fffbeb' : '#fef2f2';
                return (
                  <div key={city.name} style={Object.assign({}, S.cityNode, { top: city.top, left: city.left, borderColor: bc, background: bg })}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 5, marginBottom: 3 }}>
                      <div style={{ width: 9, height: 9, borderRadius: '50%', background: bc }} />
                      <span style={{ fontWeight: 600, fontSize: 12 }}>{city.label}</span>
                    </div>
                    <div style={{ fontSize: 11, color: '#4b5563', lineHeight: 1.5 }}>
                      <div>{d.count} bien(s)</div>
                      <div>{d.enc} charge(s)</div>
                      <div style={{ fontWeight: 500 }}>Purification : {pct}%</div>
                    </div>
                  </div>
                );
              })}
              <div style={{ position: 'absolute', bottom: 10, right: 14, background: '#fff', border: '1px solid #e5e7eb', borderRadius: 6, padding: '6px 10px', fontSize: 10, color: '#4b5563' }}>
                <div style={{ fontWeight: 500, marginBottom: 3 }}>Legende :</div>
                {[{ c: '#dc2626', l: '< 25%' }, { c: '#d97706', l: '25-75%' }, { c: '#059669', l: '> 75%' }].map(function (x) {
                  return <div key={x.l} style={{ display: 'flex', alignItems: 'center', gap: 5, marginBottom: 1 }}><div style={{ width: 9, height: 9, borderRadius: '50%', background: x.c }} />{x.l}</div>;
                })}
              </div>
            </div>
          </div>
        )}

        {/* ===== DOCUMENTS ===== */}
        {activeTab === 'docs' && (
          <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 8, padding: 20 }}>
            <h2 style={{ fontSize: 17, fontWeight: 600, margin: '0 0 14px 0' }}>Documents justificatifs</h2>
            {(function () {
              var allDocs = [];
              properties.forEach(function (p) {
                (p.encumbrances || []).forEach(function (e) {
                  (e.justificatifs || []).forEach(function (j) {
                    allDocs.push(Object.assign({}, j, { propertyRef: p.ref, propertyName: p.name, encType: e.type }));
                  });
                });
              });
              if (allDocs.length === 0) return <div style={{ textAlign: 'center', padding: '32px 0', color: '#9ca3af', fontSize: 13 }}>Aucun document uploade.</div>;
              var grouped = { valide: [], incomplet: [], expire: [] };
              allDocs.forEach(function (d) { (grouped[d.ai_status] || grouped.incomplet).push(d); });
              return ['valide', 'incomplet', 'expire'].map(function (status) {
                var docs = grouped[status];
                if (docs.length === 0) return null;
                var colors = { valide: { bg: '#d1fae5', c: '#065f46' }, incomplet: { bg: '#fef3c7', c: '#92400e' }, expire: { bg: '#fee2e2', c: '#991b1b' } };
                var col = colors[status];
                return (
                  <div key={status} style={{ marginBottom: 16 }}>
                    <h3 style={{ fontSize: 14, fontWeight: 600, marginBottom: 8, display: 'flex', alignItems: 'center', gap: 6 }}>
                      <span style={Object.assign({}, S.badge, { background: col.bg, color: col.c })}>{status}</span>
                      <span style={{ color: '#6b7280', fontWeight: 400 }}>({docs.length})</span>
                    </h3>
                    {docs.map(function (d) {
                      return (
                        <div key={d.id} style={S.docCard}>
                          <div>
                            <div style={{ fontWeight: 500, fontSize: 13 }}>{d.filename}</div>
                            <div style={{ fontSize: 11, color: '#6b7280', marginTop: 2 }}>{d.propertyRef} -- {d.encType} | {d.ai_summary || 'Pas de resume'}</div>
                          </div>
                          <div style={{ display: 'flex', gap: 4 }}>
                            <a href={API + '/api/justificatifs/' + d.id + '/download'} style={Object.assign({}, S.btnS, { textDecoration: 'none', padding: '3px 8px', fontSize: 11 })}>Telecharger</a>
                            {isAdmin && <button style={Object.assign({}, S.btnS, { padding: '3px 8px', fontSize: 11, color: '#dc2626' })} onClick={async function () { await api('/justificatifs/' + d.id, { method: 'DELETE' }); loadData(); }}>Supprimer</button>}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                );
              });
            })()}
          </div>
        )}

        {/* ===== UPLOAD ===== */}
        {activeTab === 'upload' && (
          <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 8, padding: 20 }}>
            <h2 style={{ fontSize: 17, fontWeight: 600, margin: '0 0 6px 0' }}>Upload de documents</h2>
            <p style={{ fontSize: 12, color: '#6b7280', marginBottom: 14 }}>
              Deposez un ou plusieurs fichiers PDF. Chaque document sera analyse par l IA et importe comme titre foncier ou relie a une charge existante.
            </p>
            {!isAdmin ? (
              <div style={S.err}>Seul l administrateur peut uploader des documents.</div>
            ) : (
              <>
                <div
                  style={dragOver ? S.uploadA : S.upload}
                  onDrop={function (e) {
                    e.preventDefault(); setDragOver(false);
                    var files = e.dataTransfer.files;
                    if (files.length === 1) { handleUpload(files[0]); }
                    else if (files.length > 1) { handleBatchUpload(files); }
                  }}
                  onDragOver={function (e) { e.preventDefault(); setDragOver(true); }}
                  onDragLeave={function () { setDragOver(false); }}
                >
                  {uploading || batchRunning ? (
                    <div><div style={{ fontSize: 14, color: '#4b5563' }}>Analyse en cours...</div></div>
                  ) : (
                    <div>
                      <div style={{ fontSize: 24, color: '#9ca3af', marginBottom: 10 }}>[PDF]</div>
                      <p style={{ fontSize: 13, color: '#4b5563', marginBottom: 10 }}>Glissez-deposez un ou plusieurs fichiers PDF ici</p>
                      <div style={{ display: 'flex', gap: 8, justifyContent: 'center', flexWrap: 'wrap' }}>
                        <label style={Object.assign({}, S.btnD, { cursor: 'pointer', display: 'inline-block' })}>
                          Importer titres fonciers (multi)
                          <input type="file" accept=".pdf,application/pdf" multiple style={{ display: 'none' }} onChange={function (e) {
                            var files = e.target.files;
                            if (!files || files.length === 0) return;
                            if (files.length === 1) { handleUpload(files[0]); }
                            else { handleBatchUpload(files); }
                            e.target.value = '';
                          }} />
                        </label>
                        <label style={Object.assign({}, S.btnS, { cursor: 'pointer', display: 'inline-block' })}>
                          Justificatif (1 fichier)
                          <input type="file" accept=".pdf,application/pdf" style={{ display: 'none' }} onChange={function (e) {
                            handleUpload(e.target.files && e.target.files[0]);
                            e.target.value = '';
                          }} />
                        </label>
                      </div>
                    </div>
                  )}
                </div>

                {/* Batch progress list */}
                {batchFiles.length > 0 && (
                  <div style={{ marginTop: 14 }}>
                    <div style={{ fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 8 }}>
                      Progression ({batchFiles.filter(function (f) { return f.status === 'done'; }).length}/{batchFiles.length})
                    </div>
                    {batchFiles.map(function (f, i) {
                      var statusStyle = {
                        pending: { bg: '#f3f4f6', color: '#6b7280', label: 'En attente' },
                        processing: { bg: '#dbeafe', color: '#1e40af', label: 'Analyse en cours...' },
                        done: { bg: '#d1fae5', color: '#065f46', label: 'Termine' },
                        error: { bg: '#fee2e2', color: '#991b1b', label: 'Erreur' },
                      }[f.status];
                      return (
                        <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '8px 12px', background: i % 2 === 0 ? '#fafafa' : '#fff', borderRadius: 6, marginBottom: 2 }}>
                          <span style={Object.assign({}, S.badge, { background: statusStyle.bg, color: statusStyle.color, minWidth: 110, textAlign: 'center' })}>
                            {statusStyle.label}
                          </span>
                          <span style={{ fontSize: 13, fontWeight: 500, color: '#1f2937', flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{f.name}</span>
                          <span style={{ fontSize: 12, color: f.status === 'error' ? '#dc2626' : '#6b7280', maxWidth: 300, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{f.message}</span>
                        </div>
                      );
                    })}
                    {!batchRunning && batchFiles.length > 0 && (
                      <button style={Object.assign({}, S.btnS, { marginTop: 8, fontSize: 12 })} onClick={function () { setBatchFiles([]); }}>Effacer la liste</button>
                    )}
                  </div>
                )}
              </>
            )}
            {uploadMsg.t && <div style={uploadMsg.type === 'err' ? S.err : S.ok}>{uploadMsg.t}</div>}
          </div>
        )}
      </div>

      {/* Letter modal */}
      {letterModal.open && (
        <div style={S.modal} onClick={function () { setLetterModal({ open: false, content: '', loading: false }); }}>
          <div style={S.modalBox} onClick={function (e) { e.stopPropagation(); }}>
            <div style={S.modalH}>
              <h3 style={{ fontSize: 15, fontWeight: 600, margin: 0 }}>Courrier juridique</h3>
              <button onClick={function () { setLetterModal({ open: false, content: '', loading: false }); }} style={{ background: 'none', border: 'none', fontSize: 18, color: '#9ca3af', cursor: 'pointer' }}>x</button>
            </div>
            <div style={S.modalB}>
              {letterModal.loading ? <div style={{ textAlign: 'center', padding: 20, color: '#6b7280' }}>Generation en cours...</div> : (
                <>
                  <pre style={{ whiteSpace: 'pre-wrap', fontSize: 12, color: '#374151', fontFamily: 'system-ui', lineHeight: 1.6, margin: 0 }}>{letterModal.content}</pre>
                  <div style={{ marginTop: 14, display: 'flex', justifyContent: 'flex-end' }}>
                    <button style={S.btnD} onClick={function () { navigator.clipboard.writeText(letterModal.content); }}>Copier</button>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Match modal */}
      {matchModal.open && (
        <div style={S.modal} onClick={function () { setMatchModal({ open: false, matches: [], justId: null, aiResult: null }); }}>
          <div style={S.modalBox} onClick={function (e) { e.stopPropagation(); }}>
            <div style={S.modalH}>
              <h3 style={{ fontSize: 15, fontWeight: 600, margin: 0 }}>Ce document correspond probablement a :</h3>
              <button onClick={function () { setMatchModal({ open: false, matches: [], justId: null, aiResult: null }); }} style={{ background: 'none', border: 'none', fontSize: 18, color: '#9ca3af', cursor: 'pointer' }}>x</button>
            </div>
            <div style={S.modalB}>
              {matchModal.aiResult && (
                <div style={{ marginBottom: 14, padding: 10, background: '#f9fafb', borderRadius: 8, fontSize: 12, color: '#4b5563' }}>
                  <b>Analyse IA :</b> {matchModal.aiResult.summary || 'Pas de resume'} | Status : <span style={Object.assign({}, S.badge, { background: matchModal.aiResult.status === 'valide' ? '#d1fae5' : '#fef3c7', color: matchModal.aiResult.status === 'valide' ? '#065f46' : '#92400e' })}>{matchModal.aiResult.status}</span>
                </div>
              )}
              {matchModal.matches.map(function (m) {
                return (
                  <label key={m.encumbranceId} style={{ display: 'flex', alignItems: 'flex-start', gap: 8, padding: 10, border: '1px solid ' + (selectedMatch === m.encumbranceId ? '#4f46e5' : '#e5e7eb'), borderRadius: 8, marginBottom: 8, cursor: 'pointer', background: selectedMatch === m.encumbranceId ? '#eef2ff' : '#fff' }}>
                    <input type="radio" name="match" checked={selectedMatch === m.encumbranceId} onChange={function () { setSelectedMatch(m.encumbranceId); }} style={{ marginTop: 2 }} />
                    <div>
                      <div style={{ fontWeight: 500, fontSize: 13 }}>{m.propertyRef} -- {m.propertyName}</div>
                      <div style={{ fontSize: 12, color: '#6b7280' }}>{m.encumbranceType} | {formatDH(m.amount)} | {m.creditor}</div>
                      <div style={{ fontSize: 11, color: '#4f46e5', marginTop: 2 }}>Score : {m.matchScore}% -- {m.matchReason}</div>
                    </div>
                  </label>
                );
              })}
              <div style={{ marginTop: 14, display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
                <button style={S.btnS} onClick={function () { setMatchModal({ open: false, matches: [], justId: null, aiResult: null }); }}>Annuler</button>
                <button style={S.btnD} onClick={confirmMatch}>Confirmer</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Footer */}
      <div style={Object.assign({}, S.maxW, { borderTop: '1px solid #e5e7eb', marginTop: 24, padding: '14px 20px', textAlign: 'center', fontSize: 11, color: '#9ca3af' })}>
        Dossier Amrouche -- Conservation Fonciere -- Document confidentiel
      </div>
    </div>
  );
}

export default App;
